var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-4"},[(_vm.to)?_c('router-link',{attrs:{"to":_vm.to}},[_c('Button',{attrs:{"type":"button","noMargin":""}},[_c('i',{staticClass:"fas fa-chevron-left"}),_vm._v(" "+_vm._s(_vm.title))])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }